import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEmployerBenefitPriceById = benefitId =>
  call(websocketFetch, 'get_benefit_price', {
    benefit_id: benefitId,
  });
